module.exports = __webpack_public_path__ + "img/employer_hero.0927da5a.jpg";